module.exports = "https://static.wanderu.com/ui-react/_next/static/media/not-found-chiku.5a37a54f.svg";